import VersionedFields, { latestVersions } from "../../../versions/index";

type VersionKeys = keyof typeof VersionedFields;

const getVersionedFields = (loanType: any, version?: VersionKeys) => {
    const versionToUse = (version || latestVersions?.[loanType])?.includes("bridge") ? "bridgeV1" : "dscrV1";
    return VersionedFields?.[versionToUse];
};

export default getVersionedFields;